/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "etsɔ si va yi",
      "-2": "nyitsɔ si va yi",
      "0": "egbe",
      "1": "etsɔ si gbɔna",
      "2": "nyitsɔ si gbɔna",
      "future": {
        "one": "le ŋkeke {0} me",
        "other": "le ŋkeke {0} wo me"
      },
      "past": {
        "one": "ŋkeke {0} si va yi",
        "other": "ŋkeke {0} si wo va yi"
      }
    },
    "day-narrow": {
      "-1": "etsɔ si va yi",
      "-2": "nyitsɔ si va yi",
      "0": "egbe",
      "1": "etsɔ si gbɔna",
      "2": "nyitsɔ si gbɔna",
      "future": {
        "one": "le ŋkeke {0} me",
        "other": "le ŋkeke {0} wo me"
      },
      "past": {
        "one": "ŋkeke {0} si va yi",
        "other": "ŋkeke {0} si wo va yi"
      }
    },
    "day-short": {
      "-1": "etsɔ si va yi",
      "-2": "nyitsɔ si va yi",
      "0": "egbe",
      "1": "etsɔ si gbɔna",
      "2": "nyitsɔ si gbɔna",
      "future": {
        "one": "le ŋkeke {0} me",
        "other": "le ŋkeke {0} wo me"
      },
      "past": {
        "one": "ŋkeke {0} si va yi",
        "other": "ŋkeke {0} si wo va yi"
      }
    },
    "hour": {
      "0": "this hour",
      "future": {
        "one": "le gaƒoƒo {0} me",
        "other": "le gaƒoƒo {0} wo me"
      },
      "past": {
        "one": "gaƒoƒo {0} si va yi",
        "other": "gaƒoƒo {0} si wo va yi"
      }
    },
    "hour-narrow": {
      "0": "this hour",
      "future": {
        "one": "le gaƒoƒo {0} me",
        "other": "le gaƒoƒo {0} wo me"
      },
      "past": {
        "one": "gaƒoƒo {0} si va yi",
        "other": "gaƒoƒo {0} si wo va yi"
      }
    },
    "hour-short": {
      "0": "this hour",
      "future": {
        "one": "le gaƒoƒo {0} me",
        "other": "le gaƒoƒo {0} wo me"
      },
      "past": {
        "one": "gaƒoƒo {0} si va yi",
        "other": "gaƒoƒo {0} si wo va yi"
      }
    },
    "minute": {
      "0": "this minute",
      "future": {
        "one": "le aɖabaƒoƒo {0} me",
        "other": "le aɖabaƒoƒo {0} wo me"
      },
      "past": {
        "one": "aɖabaƒoƒo {0} si va yi",
        "other": "aɖabaƒoƒo {0} si wo va yi"
      }
    },
    "minute-narrow": {
      "0": "this minute",
      "future": {
        "one": "le aɖabaƒoƒo {0} me",
        "other": "le aɖabaƒoƒo {0} wo me"
      },
      "past": {
        "one": "aɖabaƒoƒo {0} si va yi",
        "other": "aɖabaƒoƒo {0} si wo va yi"
      }
    },
    "minute-short": {
      "0": "this minute",
      "future": {
        "one": "le aɖabaƒoƒo {0} me",
        "other": "le aɖabaƒoƒo {0} wo me"
      },
      "past": {
        "one": "aɖabaƒoƒo {0} si va yi",
        "other": "aɖabaƒoƒo {0} si wo va yi"
      }
    },
    "month": {
      "-1": "ɣleti si va yi",
      "0": "ɣleti sia",
      "1": "ɣleti si gbɔ na",
      "future": {
        "one": "le ɣleti {0} me",
        "other": "le ɣleti {0} wo me"
      },
      "past": {
        "one": "ɣleti {0} si va yi",
        "other": "ɣleti {0} si wo va yi"
      }
    },
    "month-narrow": {
      "-1": "ɣleti si va yi",
      "0": "ɣleti sia",
      "1": "ɣleti si gbɔ na",
      "future": {
        "one": "le ɣleti {0} me",
        "other": "le ɣleti {0} wo me"
      },
      "past": {
        "one": "ɣleti {0} si va yi",
        "other": "ɣleti {0} si wo va yi"
      }
    },
    "month-short": {
      "-1": "ɣleti si va yi",
      "0": "ɣleti sia",
      "1": "ɣleti si gbɔ na",
      "future": {
        "one": "le ɣleti {0} me",
        "other": "le ɣleti {0} wo me"
      },
      "past": {
        "one": "ɣleti {0} si va yi",
        "other": "ɣleti {0} si wo va yi"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "le kɔta {0} si gbɔ na me",
        "other": "le kɔta {0} si gbɔ na me"
      },
      "past": {
        "one": "kɔta {0} si va yi me",
        "other": "kɔta {0} si va yi me"
      }
    },
    "quarter-narrow": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "le kɔta {0} si gbɔna me",
        "other": "le kɔta {0} si gbɔ na me"
      },
      "past": {
        "one": "kɔta {0} si va yi me",
        "other": "kɔta {0} si va yi me"
      }
    },
    "quarter-short": {
      "-1": "last quarter",
      "0": "this quarter",
      "1": "next quarter",
      "future": {
        "one": "le kɔta {0} si gbɔ na me",
        "other": "le kɔta {0} si gbɔ na me"
      },
      "past": {
        "one": "kɔta {0} si va yi me",
        "other": "kɔta {0} si va yi me"
      }
    },
    "second": {
      "0": "fifi",
      "future": {
        "one": "le sekend {0} me",
        "other": "le sekend {0} wo me"
      },
      "past": {
        "one": "sekend {0} si va yi",
        "other": "sekend {0} si wo va yi"
      }
    },
    "second-narrow": {
      "0": "fifi",
      "future": {
        "one": "le sekend {0} me",
        "other": "le sekend {0} wo me"
      },
      "past": {
        "one": "sekend {0} si va yi",
        "other": "sekend {0} si wo va yi"
      }
    },
    "second-short": {
      "0": "fifi",
      "future": {
        "one": "le sekend {0} me",
        "other": "le sekend {0} wo me"
      },
      "past": {
        "one": "sekend {0} si va yi",
        "other": "sekend {0} si wo va yi"
      }
    },
    "week": {
      "-1": "kɔsiɖa si va yi",
      "0": "kɔsiɖa sia",
      "1": "kɔsiɖa si gbɔ na",
      "future": {
        "one": "le kɔsiɖa {0} me",
        "other": "le kɔsiɖa {0} wo me"
      },
      "past": {
        "one": "kɔsiɖa {0} si va yi",
        "other": "kɔsiɖa {0} si wo va yi"
      }
    },
    "week-narrow": {
      "-1": "kɔsiɖa si va yi",
      "0": "kɔsiɖa sia",
      "1": "kɔsiɖa si gbɔ na",
      "future": {
        "one": "le kɔsiɖa {0} me",
        "other": "le kɔsiɖa {0} wo me"
      },
      "past": {
        "one": "kɔsiɖa {0} si va yi",
        "other": "kɔsiɖa {0} si wo va yi"
      }
    },
    "week-short": {
      "-1": "kɔsiɖa si va yi",
      "0": "kɔsiɖa sia",
      "1": "kɔsiɖa si gbɔ na",
      "future": {
        "one": "le kɔsiɖa {0} me",
        "other": "le kɔsiɖa {0} wo me"
      },
      "past": {
        "one": "kɔsiɖa {0} si va yi",
        "other": "kɔsiɖa {0} si wo va yi"
      }
    },
    "year": {
      "-1": "ƒe si va yi",
      "0": "ƒe sia",
      "1": "ƒe si gbɔ na",
      "future": {
        "one": "le ƒe {0} me",
        "other": "le ƒe {0} me"
      },
      "past": {
        "one": "ƒe {0} si va yi",
        "other": "ƒe {0} si wo va yi"
      }
    },
    "year-narrow": {
      "-1": "ƒe si va yi",
      "0": "ƒe sia",
      "1": "ƒe si gbɔ na",
      "future": {
        "one": "le ƒe {0} si gbɔna me",
        "other": "le ƒe {0} si gbɔna me"
      },
      "past": {
        "one": "ƒe {0} si va yi me",
        "other": "ƒe {0} si va yi me"
      }
    },
    "year-short": {
      "-1": "ƒe si va yi",
      "0": "ƒe sia",
      "1": "ƒe si gbɔ na",
      "future": {
        "one": "le ƒe {0} me",
        "other": "le ƒe {0} me"
      },
      "past": {
        "one": "le ƒe {0} si va yi me",
        "other": "le ƒe {0} si va yi me"
      }
    }
  },
  "locale": "ee"
})
}
